<template>
  <div class="action-panel">
    <Button
      class="link download-button"
      :disabled="disableDownload"
      @click="onDownloadClick"
    >
      Download Newsletter
    </Button>

    <Button
      :disabled="disableSend"
      class="primary"
      :loading="campaignSending"
      @click="$emit('send-click')"
    >
      Send Now
    </Button>
  </div>
</template>

<script>
export default {
  name: "SendCampaignActions",

  props: {
    campaignId: {
      required: true,
      type: String,
    },
    campaignSending: {
      type: Boolean,
      default: false,
    },
    disableDownload: {
      type: Boolean,
      default: false,
    },
    disableSend: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onDownloadClick() {
      this.$modal.hide("send-campaign");

      this.$modal.show("download-campaign", {
        campaignId: this.campaignId,
      });
    },
  },
};
</script>

<style scoped>
.download-button {
  @apply flex items-center text-grey-dark font-sans text-xs ml-auto mr-1;

  &:hover {
    @apply text-brand-dark;
  }

  @screen md {
    @apply text-sm mr-0;
  }
}

.action-panel {
  @apply flex flex-wrap items-center w-full border-grey-lighter border-t bg-grey-lightest p-4 relative;

  button {
    @apply p-1;
  }

  @screen md {
    @apply p-8;

    button {
      @apply py-2 px-4;
    }
  }
}
</style>
